export default class Popup {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const close = this.el.querySelector('[data-popup-close]')
    if (!close) return

    close.addEventListener('click', () => {
      this.el.classList.add('is-closed')
      this.el.addEventListener('transitionend', () => { this.el.hidden = true }, { once: true })
    })
  }
}
